<div class="page">
  <div class="description-box">
    <div class="d-flex align-items-center gap">
      <div class="tab-btn ml-2" [class.active]="!dailyInventory" (click)="dailyInventoryShow('desc')">
        <span>{{ "ClientApp.FrontOffice.Order.OrderPage.Item.Description.DescriptionTitle" | translate }} </span>
      </div>
      <div class="tab-btn" *ngIf="!order.isLight" [class.active]="dailyInventory" (click)="dailyInventoryShow('dailyInventory')">
        <span>{{ "ClientApp.FrontOffice.Order.OrderPage.Item.Description.DailyInventory" | translate }} </span>
      </div>
      <div class="tab-btn" *ngIf="!order.isLight && dailyInventory">
        <ssg-checkbox
          [label]="'ClientApp.FrontOffice.Order.OrderPage.Item.Description.ShowMinimumJustInBasket' | translate"
          id="justInBasket"
          name="justInBasket"
          [group]="formGroup"
          (valueChange)="onShowMinimumJustInBasketChanges($event)">
        </ssg-checkbox>
      </div>
    </div>
    <div class="d-flex align-items-center gap">
      <div class="add-description" [class.d-none]="dailyInventory">
        <div
          (click)="ShowDescription()"
          class="create"
          [class.show]="order.OrderSetting ? order.OrderSetting.IsShowDescriptionBox : false"
          [class.hide]="showBox">
          <span>
            {{ "ClientApp.FrontOffice.Order.OrderPage.Item.Description.AddDescription" | translate }}
          </span>
          <i class="icon-add-o"></i>
        </div>
        <div class="adddes" [class.showadd]="showBox" [class.hide]="order.OrderSetting ? !order.OrderSetting.IsShowDescriptionBox : false">
          <ssg-input
            [group]="order.formGroup"
            name="CustomDescription{{ this.order.invoice.SaleMethodBranchId }}"
            textType="text"
            [placeholder]="'ClientApp.FrontOffice.Order.OrderPage.Item.Description.CustomDescription' | translate"
            (clear)="ClearCustomDescription()"
            [label]="'ClientApp.FrontOffice.Order.OrderPage.Item.Description.CustomDescription' | translate"
            hasClear="true"
            (onEnter)="addCustomDescription()"></ssg-input>
          <i
            class="icon-check-o okbtn"
            (click)="addCustomDescription()"
            [tooltip]="'ClientApp.FrontOffice.Order.OrderPage.Item.Description.Save' | translate"></i>
        </div>
      </div>
      <div class="collapse-button" (click)="stateChange()">
        <i class="icon" [ngClass]="{ 'icon-chevron-down11': _rotate, 'icon-chevron-up': !_rotate }"></i>
      </div>
    </div>
  </div>
  <div *ngIf="order.OrderSetting ? order.OrderSetting.IsShowDescriptionBox : false">
    <div *ngIf="dailyInventory && !order.isLight; then thenBlock; else elseBlock"></div>
    <ng-template #thenBlock>
      <div class="daily-inventory">
        <kgrid
          [showLoadingMessage]="false"
          [columns]="columns"
          [isAdd]="false"
          [isDelete]="false"
          [paging]="false"
          [isEdit]="false"
          [filtering]="false"
          [hasColumnMenu]="false"
          [hideToolber]="true"
          [dataList]="order.dailyInventoryList"
          [noAutoFitColumns]="true"
          [unSortableFilterable]="['GoodsCode', 'GoodsTitle', 'MinAmount', 'EntryAmount', 'SaleAmount', 'Amount']">
        </kgrid>
      </div>
    </ng-template>
    <ng-template #elseBlock>
      <div class="descard">
        <div
          class="desbox"
          *ngFor="let item of this.order.selectedOrderItem?.ItemDescription"
          (click)="addDescription(item)"
          [class.selectitem]="item.IsSelected">
          <div>{{ item.Title }}</div>
        </div>
        <div
          class="desbox"
          *ngFor="let additive of this.order.selectedOrderItem?.Additive"
          (click)="addAdditive(additive)"
          [class.selectitem]="additive.IsSelected">
          <div>{{ additive.Title }}</div>
          <div class="desprice">{{ additive.MainPrice | number }}</div>
        </div>
      </div>
    </ng-template>
  </div>
</div>
